export const generateRoles = (numPlayers, numSpies, gameMode, gameData, language, selectedHumanCategory) => {
    const newRoles = [];
    const spyIndices = [];

    // Randomly select spy positions
    while (spyIndices.length < numSpies) {
        const randomIndex = Math.floor(Math.random() * numPlayers);
        if (!spyIndices.includes(randomIndex)) {
            spyIndices.push(randomIndex);
        }
    }

    if (gameMode === 'location') {
        const locations = gameData.locations[language];
        const randomLocation = locations[Math.floor(Math.random() * locations.length)];

        const availableRoles = [...randomLocation.roles];
        for (let i = 0; i < numPlayers; i++) {
            if (spyIndices.includes(i)) {
                newRoles.push({
                    isSpy: true,
                    item: randomLocation.name,
                    role: null
                });
            } else {
                const roleIndex = Math.floor(Math.random() * availableRoles.length);
                const assignedRole = availableRoles.splice(roleIndex, 1)[0];
                newRoles.push({
                    isSpy: false,
                    item: randomLocation.name,
                    role: assignedRole
                });
            }
        }

        return { roles: newRoles, selectedItem: randomLocation.name };
    } else {
        const items = gameData.humans[selectedHumanCategory];
        const randomItem = items[Math.floor(Math.random() * items.length)];

        for (let i = 0; i < numPlayers; i++) {
            newRoles.push({
                isSpy: spyIndices.includes(i),
                item: randomItem,
                role: null
            });
        }

        return { roles: newRoles, selectedItem: randomItem };
    }
};